
import React, { useState, useEffect, useContext } from 'react';
import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Box,
} from '@mui/material';
import {Modal,   IconButton, TextField} from '@mui/material';
import ThumbDownAltOutlined from '@mui/icons-material/ThumbDownAltOutlined'
import ThumbUpAltOutlined from '@mui/icons-material/ThumbUpAltOutlined'
import { ThumbUpAlt } from '@mui/icons-material';

import { motion } from 'framer-motion';
import ProgressContext from '../context/ProgressContext';
import { UserContext } from '../context/UserContext';
import { replace, useNavigate } from 'react-router-dom';
import HorizontalStepper from '../components/HorizontalStepper';
import BackButton from '../components/BackButton';
import axios from 'axios';
import { Editor, EditorState, ContentState, convertToRaw } from 'draft-js';
import { ThumbDownAlt } from '@mui/icons-material';


import 'draft-js/dist/Draft.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DOMPurify from 'dompurify';

import apiClient from '../utils/apiClient';

function SummaryCreation() {
  const { steps, currentStep, setCurrentStep } = useContext(ProgressContext);
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
  const {
    agentStrategy,
    pitchResponse,
    ebiExplanations,
    comparisonOutput,
    selectedProducts,
    selectedProductCodes,
    segmentName,
    customerName,
    customerNeeds,
    summary,
    setSummary,
  } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  const [feedback_open, setFeedback_open] = useState(0)
  const [feedback_liked, setFeedback_licked] = useState(false)
  const [feedback_disliked, setFeedback_dislicked] = useState(false)
  const [feedback_value, feedback_value_set] = useState('')

  const dislikeFeedback = async () =>{
    if (!feedback_liked && !feedback_disliked) {
      setFeedback_open(1)
    }
  }
  const likeFeedback = async () => {
    if (!feedback_liked && !feedback_disliked) {
      const response = await apiClient.post('/feedback', {
        "session_id": userNTID,
        "query": "EBI Generation",
        "response": "",
        "feedback": "thumbs_up",
        "product": "",
        "ntID": userNTID

      }, { withCredentials: true });

      setFeedback_licked(true)
    }

  }
    const FeedbackPopupClose = () =>{
    setFeedback_open(0)
  }
  
  const submitFeedback = async() =>{
    if(!feedback_disliked){
      const response = await apiClient.post('/feedback', {
        "session_id":userNTID,
        "query":"EBI Generation",
        "response":feedback_value,
        "feedback":"thumbs_down",
        "product":"",
        "ntID":userNTID
      }, { withCredentials:true });
      FeedbackPopupClose()
      setFeedback_dislicked(true)
      }

  }

  // Set the current step on component mount
  useEffect(() => {
    const stepIndex = steps.findIndex((step) => step.path === '/dashboard/summary-creation');
    if (stepIndex !== -1) {
      setCurrentStep(stepIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const replaceNullWithBlank=(obj)=>{
    for (const key in obj){
      if(obj[key] === null){
        obj[key] ={};
      }else if(typeof obj[key]==='object' && obj[key]!==null){
        replaceNullWithBlank(obj[key]);
      }
    }
    return obj
  }

  const generateSummary = async () => {
    setLoading(true);
    // Prepare data for API call
    let requestData = {
      agent_strategy: agentStrategy,
      pitch_response: pitchResponse.replace(/(<([^>]+)>)/gi, " ").replace(/\s+/g, " ").trim(),
      ebi_explanations: ebiExplanations,
      comparison_output: comparisonOutput,
      selected_products: selectedProducts,
      selected_product_codes: selectedProductCodes,
      segment_name: segmentName,
      customer_needs:customerNeeds,
      ntID: userNTID
    };
    requestData = replaceNullWithBlank(requestData)

    try {
      // const response = await axios.post(
      //   'http://localhost:8000/liva/api/summary',
      const response = await apiClient.post(
        '/summary',
        requestData,
        { withCredentials: true }
      );
      const data = response.data;
      // Convert plain text to ContentState and initialize EditorState
      const contentState = ContentState.createFromText(data.personalized_summary || '');
      setEditorState(EditorState.createWithContent(contentState));
      // Store summary in context
      setSummary(data.personalized_summary);
      setLoading(false);
      setEditorLoaded(true);
    } catch (error) {
      console.error('Error generating summary:', error);
      setLoading(false);
    }
  };
  // Generate summary on component mount if not already generated
  useEffect(() => {
    if (!summary) {
      generateSummary();
    } else {
      const contentState = ContentState.createFromText(summary);
      setEditorState(EditorState.createWithContent(contentState));
      setEditorLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
     const handlePopState = () => window.history.pushState(null, "", window.location.href);
     window.history.pushState(null, "", window.location.href);
     window.addEventListener("popstate", handlePopState);
     return () => window.removeEventListener("popstate", handlePopState);
  }, []);
  
  const handleEditorChange = (newState) => {
    setEditorState(newState);
  };
  const handleDownloadPDF = async () => {
    const doc = new jsPDF('p', 'pt', 'a4');
  
    // Fetch the ICICI Prudential logo
    let logoImg;
    try {
      const logoResponse = await axios.get('src\static\ipru.jpg', {
        responseType: 'arraybuffer',
      });
      const logoBlob = new Blob([logoResponse.data], { type: 'image/jpeg' });
      const logoUrl = URL.createObjectURL(logoBlob);
      const img = new Image();
      img.src = logoUrl;
      await new Promise((resolve) => {
        img.onload = () => resolve();
      });
      logoImg = img;
    } catch (error) {
      console.error("Failed to fetch logo:", error);
    }
  
    // Add the header section
    if (logoImg) {
      doc.addImage(logoImg, 'JPEG', 40, 40, 60, 60); // Adjust position and size
    }
  
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 102, 204); // ICICI Blue
    doc.text('ICICI Prudential Life Insurance', 120, 60);
  
    doc.setFontSize(12);
    doc.setTextColor(255, 102, 0); // ICICI Orange
    doc.text('Personalized Insurance Recommendation', 120, 80);
  
    // Decorative Lines
    doc.setDrawColor(255, 102, 0); // Orange color
    doc.setLineWidth(1);
    doc.line(20, 120, doc.internal.pageSize.width - 20, 120);
  
    // Add customer details
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0); // Black
    // doc.text(`Customer Name: John Doe`, 40, 140);
    // doc.text(`Segment: ${segmentName}`, 40, 160);
  
    // Summary Content
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(255, 102, 0); // Orange
    doc.text('Summary:', 40, 200);
  
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0); // Black
    const rawContent = convertToRaw(editorState.getCurrentContent());
    const plainText = rawContent.blocks.map((block) => block.text).join('\n');
    const splitText = doc.splitTextToSize(plainText, 500);
    doc.text(splitText, 40, 220);
  
    // Footer Section
    const footerY = doc.internal.pageSize.height - 50;
    doc.setFontSize(10);
    doc.setTextColor(0, 102, 204); // Blue
    doc.text('Generated by ICICI Prudential Life Insurance - Confidential', 40, footerY);
  
    doc.save('Personalized_Insurance_Recommendation.pdf');
  };
  
  const handleLogout = async () => {
    try {
      // await axios.get('http://localhost:8000/liva/auth/logout', { withCredentials: true });
      await apiClient.post('/logout', 
      {
        ntID: userNTID
      },
      { withCredentials: true });
      // Redirect to login page or home page
      navigate('/');
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  const handleEditToggle = () => {
    setIsEditable(!isEditable);
  };
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
                  <Modal
              open={feedback_open}
              onClose={()=>{setFeedback_open(0)}}
              >
                        <div style={{ margin: '250px'}}>
                <div style={{padding:'20px', backgroundColor:'white', overflowY:'scroll', height:'250px', width:'100%', marginLeft:'0'}}>
                  <Typography  variant="h6" gutterBottom sx={{ mt: 2 }}>
                    <h4>Please provide your feedback and opinion. </h4>
                  </Typography>
                  <TextField minRows={3} sx={{width:'100%', 'marginBottom': '5'}} placeholder='Tell us your feedback'value={feedback_value} onChange={(e)=>{feedback_value_set(e.target.value)}}/>
      
                  <Button variant="contained" color="primary" sx = {{float: 'right',  marginTop:'15px' }} onClick={submitFeedback}>Submit</Button>
                  <Button variant="outlined" color="primary" sx = {{float: 'right', marginTop:'15px', marginRight:'15px'}} onClick={FeedbackPopupClose}>Close</Button>
      
                         
                  </div>
            </div>
      
              </Modal>
      
      <HorizontalStepper />
      <BackButton />
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Summary Creation
        </Typography>
        {loading ? (
          <CircularProgress sx={{ mt: 4 }} />
        ) : (
          <Card
            sx={{
              mt: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
              borderRadius: 2,
            }}
          >
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                📝 Summary:
              </Typography>
              {!editorLoaded && <CircularProgress sx={{ mt: 4 }} />}
              {editorLoaded && !isEditable && (
                <div
                  style={{
                    border: '1px solid #ddd',
                    padding: '10px',
                    minHeight: '300px',
                    borderRadius: '4px',
                    background: '#f9f9f9',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: editorState
                      .getCurrentContent()
                      .getPlainText()
                      .replace(/\n/g, '<br>'),
                  }}
                ></div>
              )}
              {editorLoaded && isEditable && (
                <div
                  style={{
                    border: '1px solid #ddd',
                    padding: '10px',
                    minHeight: '300px',
                    borderRadius: '4px',
                  }}
                >
                  <Editor
                    editorState={editorState}
                    onChange={handleEditorChange}
                  />
                </div>
              )}
            <div sx={{ width:'100%'}}>
                            <IconButton  onClick={()=>{likeFeedback()}}>
                                {!feedback_liked ? (
                                  <ThumbUpAltOutlined sx={{color: "rgb(112 48 160)"}}/>
                                ):(
                                 <ThumbUpAlt sx={{color: "rgb(112 48 160)"}}/>
                                )}
                            </IconButton>
                            <IconButton onClick={()=>{dislikeFeedback()}}>
                            {!feedback_disliked ?(
                              <ThumbDownAltOutlined sx={{color: "rgb(112 48 160)"}}/>
                            ):(
                              <ThumbDownAlt sx={{color: "rgb(112 48 160)"}}/>
                            )}
                            </IconButton>

               </div>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadPDF}
                >
                  Download Summary as PDF
                </Button>
                <Button
                  variant="contained"
                  color={isEditable ? 'success' : 'secondary'}
                  onClick={handleEditToggle}
                >
                  {isEditable ? 'Save Summary' : 'Edit Summary'}
                </Button>
                <Button variant="contained" color="secondary" onClick={handleLogout}>
                  Logout
                </Button>
              </Box>
            </CardContent>
          </Card>
        )}
      </motion.div>
    </Container>
  );
}
export default SummaryCreation;
